import { Page } from '@/core/architecture'

import { CollectionDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * CollectionDetail Page
 * Implemented as a practical sample.
 */
export const CollectionDetail: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <CollectionDetailTemplate
      state={state}
      onChangeLabel={actions.onChangeLabel}
      onClickShare={actions.onClickShare}
      onFetchMore={actions.onFetchMore}
    />
  )
}
